<script>
    export let copySource

    export let isProduction = window.location.href.indexOf("localhost") > -1 || window.location.href.indexOf("staging") > -1;
</script>

<style>
    nav {
        display: flex;
        justify-content: space-between;
        background: #fff;
        height: 112px;
        max-width: 1440px;
        margin: auto;
        font-family: 'Swiss721 Regular';
    }

    nav > a {
        flex-basis: 35%;
        text-align: left;
    }

    nav > a > img {
        margin-top: -20px;
        margin-left: 11%;
        width: 100%;
        max-width: 200px;
    }
    

    nav > ul {
        display:flex;
        flex-basis: 65%;
        justify-content: flex-end;
        align-items: center;
        width: 30%;
        margin-right: 30px;
        
    }
    
    li {
        display:flex;
        align-items: center;
        margin-right: 40px;
        white-space: nowrap;
    }

    nav > ul > li:last-of-type > a {
        border-bottom: 1px solid #1c1c1c;
    }

    a {
        display: inline-block;
        position: relative;
        z-index: 2;
        font-weight: bold;
        font-size: 16px;
        line-height: 20px;
        text-decoration: none;
        color: #1C1C1C;
    }

    @media screen and (max-width: 775px) {
        nav > ul {
            margin-right: 0px;
        }

        nav > ul > li {
            margin-right: 15px;
        }
    }

    @media screen and (max-width: 700px) {

        nav {
            height: 80px;
        }
        nav > a {
            flex-basis: 70%;
        }

        nav > a > img {
            max-width: 140px;
        }
        nav > ul {
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            flex-basis: 160px;
            margin-right: 10px;
        }
        li:lang(ja) {
            margin-right:0px;
        }
    }

    @media only screen and (max-width: 500px) {
        nav > ul{
            flex-basis: 40%;
        }
        nav > ul:lang(ja){
            flex-basis: 50%;
        }

        nav > ul > li > a{
            font-size: 14px;
        }

        nav > a {
            flex-basis: 50%;
        }
    }

    @media all and (-ms-high-contrast: none), all and (-ms-high-contrast: active) {
        /* IE10+ CSS styles go here */
        nav > ul:lang(ja) {
            flex-basis: 450px;
        
        }
    }

</style>


<nav> 
    <a class ="logo-link" href="{copySource.headerNav.logo.link}">
        <img src="./images/mr-logo_2022.png" alt="{copySource.headerNav.logo.alt}"/>
    </a>
    <ul>
        <li><a href="{isProduction ? copySource.headerNav.buy.stLink : copySource.headerNav.buy.link}">{copySource.headerNav.buy.copy}</a></li>
        <li><a href="{isProduction ? copySource.headerNav.gift.stLink : copySource.headerNav.gift.link}">{copySource.headerNav.gift.copy}</a></li>
        <li><a href="{copySource.headerNav.mr.link}">{copySource.headerNav.mr.copy}</a></li>
    </ul>
</nav>

